import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { SharedService } from "./shared.service";

@Injectable()
export class SessionService {
    public sessionListAPI: string = "/svcs/conference_sessions/list";
    public sessionTypeAPI: string = "/svcs/session_catalog/app/confSessionTypes/list/";
    public sessionStatusAPI: string = "/svcs/session_catalog/app/conference_session_statuses/";
    public sessionTracksAPI: string =
        "/svcs/session_catalog/app/" +
        this.sharedService.event.id +
        "/tracks?limit=-1&sort=trackName&trackName.dir=asc";
    public sessionLevelAPI: string = "/svcs/session_catalog/app/confSessionLevels/list/";
    public industriesAPI: string = "/svcs/session_catalog/app/industry/accessible";
    public jobFunctionsAPI: string = "/svcs/session_catalog/app/jobFunction/accessible";
    public productGoalsAPI: string = "/svcs/session_catalog/app/productGoal/accessible";
    public sessionTagAPI: string =
        "/svcs/session_catalog/app/tags?accountId=" + this.sharedService.event.accountId + "&limit=-1&tagObjectIds=2";
    public sessionLocationAPI: string = "/svcs/session_catalog/app/conference_locations/list";
    public sessionInstanceDateAPI: string =
        "/svcs/session_catalog/app/sessionInstanceDateList/?eventId=" + this.sharedService.event.id + "&getAllDates=" + true;
    public attendeeTypeApi: string = "/svcs/attendee_types?limit=-1&eventId=";

    constructor(private http: HttpClient, public sharedService: SharedService) {}

    public getSessionTypes(eventId: number) {
        return this.http.get(this.sessionTypeAPI + eventId, {
            observe: "response",
            headers: this.sharedService.headers
        }).toPromise();
    }

    public getSessionInstanceDates() {
        return this.http.get(this.sessionInstanceDateAPI, {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public getSessionStatus() {
        return this.http.get(this.sessionStatusAPI, {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public getSessionTracks() {
        return this.http.get(this.sessionTracksAPI, {
            observe: "response",
            headers: this.sharedService.headers
        }).toPromise();
    }

    public getSessionLevels(eventId: number) {
        return this.http.get(this.sessionLevelAPI + eventId, {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public getIndustries(accountCode: string, eventCode: string) {
        return this.http.get(this.industriesAPI + '?accountCode=' + accountCode + '&eventCode=' + eventCode, {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public getJobFunctions(accountCode: string, eventCode: string) {
        return this.http.get(this.jobFunctionsAPI + '?accountCode=' + accountCode + '&eventCode=' + eventCode, {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public getProductGoals(accountId: string, eventId: string) {
        return this.http.get(this.productGoalsAPI + '?accountId=' + accountId + '&eventId=' + eventId, {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public getSessiontags() {
        return this.http.get(this.sessionTagAPI, {
            observe: "response",
            headers: this.sharedService.headers
        });
    }
    public getSessionLocations(eventId: number) {
        let locationFilter = {
            eventId: eventId,
            active: true,
            typeIds: [],
            limit: -1,
            sortField: "name",
            order: "asc",
            page: 0
        };
        return this.http.post(this.sessionLocationAPI, locationFilter, {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public sessionList(sessionConfig: any) {
        return this.http.post(this.sessionListAPI, JSON.stringify(sessionConfig), {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public getAttendeeTypes() {
        return this.http.get(this.attendeeTypeApi + this.sharedService.event.id, {
            observe: "response",
            headers: this.sharedService.headers
        });
    }
}
